// src/components/PixiGame.js
import React from "react";
import { Stage, Graphics, Text } from "@pixi/react";
import * as PIXI from "pixi.js";  

const PixiGame = () => {
  // Function for drawing circle with Graphics
  const drawCircle = (g) => {
    g.clear();
    g.beginFill(0xffc0cb); // pastel pink
    g.drawCircle(150, 150, 60);
    g.endFill();
  };

  return (
    <Stage
      width={500}
      height={400}
      options={{ backgroundColor: 0xe0f7fa }} // pastel blue background
    >
      {/* Circle */}
      <Graphics draw={drawCircle} />

      {/* Text */}
      <Text
        text="Hello Kids 🎨"
        x={220}
        y={130}
        style={
          new PIXI.TextStyle({
            fill: "#333333",
            fontSize: 24,
            fontWeight: "bold",
          })
        }
      />
    </Stage>
  );
};

export default PixiGame;
